/* eslint-disable react/require-default-props */
import React, { Suspense } from 'react';

import HtmlWrapper from '../html-wrapper/html-wrapper';

const MatchReportsWrapper = React.lazy(() => import('./match-reports'));

export interface IDynamicMatchReports {
  model: any;
  query?: {};
  children?: React.ReactNode;
  live?: boolean;
}

// TODO ADD use Service if component need to do Query or Subs
const DynamicMatchReports = ({
  /* istanbul ignore next: default value */ model = {},
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  /* istanbul ignore next: default value */ live = false,
}: IDynamicMatchReports) => {
  return (
    <Suspense fallback={<HtmlWrapper html={children} />}>
      <MatchReportsWrapper live={live} initialModel={model} query={query} />
    </Suspense>
  );
};

export default DynamicMatchReports;
